import { createReducer } from "@reduxjs/toolkit";

export const rootReducer = createReducer(
  {
    isAuthenticated: localStorage.getItem("accessToken") != null ? true : false,
  },
  {
    login: (state) => {
      state.isAuthenticated = true;
    },
    logout: (state) => {
      state.isAuthenticated = false;
    },
  }
);
